module.exports = __webpack_public_path__ + "static/media/about.6ea7d7bf.webp";